import { getCurrentUser } from './auth.js';
import { apiPut, apiPost } from './api.js';

const modal = document.getElementById('profileModal');
const closeButton = document.getElementById('closeProfileModal');
const profileForm = document.getElementById('profileForm');
const passwordForm = document.getElementById('passwordForm');
const messageArea = document.getElementById('profileMessage');

/**
 * Open the profile modal
 */
export function openProfileModal() {
    const user = getCurrentUser();
    
    if (!user) {
        console.error('No user logged in');
        return;
    }
    
    // Populate fields with current user data
    document.getElementById('profileDisplayName').value = user.displayName || '';
    document.getElementById('profileEmail').value = user.email || '';
    
    // Clear password fields
    document.getElementById('currentPassword').value = '';
    document.getElementById('newPassword').value = '';
    document.getElementById('confirmPassword').value = '';
    
    // Clear message
    hideMessage();
    
    // Show modal
    modal.classList.add('active');
}

/**
 * Close the profile modal
 */
function closeProfileModal() {
    modal.classList.remove('active');
    
    // Clear password fields
    document.getElementById('currentPassword').value = '';
    document.getElementById('newPassword').value = '';
    document.getElementById('confirmPassword').value = '';
    
    // Clear message
    hideMessage();
}

/**
 * Handle profile save (display name update)
 */
async function handleSaveProfile(e) {
    e.preventDefault();
    
    const user = getCurrentUser();
    const displayName = document.getElementById('profileDisplayName').value.trim();
    
    if (!displayName) {
        showMessage('Display name is required', 'error');
        return;
    }
    
    const saveButton = document.getElementById('saveProfileButton');
    saveButton.disabled = true;
    saveButton.textContent = 'Saving...';
    
    try {
        const response = await apiPut(`/api/auth/users/${user.id}`, { displayName });
        
        const data = await response.json();
        
        if (response.ok && data.success) {
            showMessage('Profile updated successfully', 'success');
            // Update local user data
            user.displayName = data.user.displayName;
            document.getElementById('userMenuName').textContent = data.user.displayName;
        } else {
            showMessage(data.error || 'Failed to update profile', 'error');
        }
    } catch (error) {
        console.error('Save profile error:', error);
        showMessage('Network error', 'error');
    } finally {
        saveButton.disabled = false;
        saveButton.textContent = 'Save profile';
    }
}

/**
 * Handle password change
 */
async function handleChangePassword(e) {
    e.preventDefault();
    
    const currentPassword = document.getElementById('currentPassword').value;
    const newPassword = document.getElementById('newPassword').value;
    const confirmPassword = document.getElementById('confirmPassword').value;
    
    // Validation
    if (!currentPassword || !newPassword || !confirmPassword) {
        showMessage('All password fields are required', 'error');
        return;
    }
    
    if (newPassword !== confirmPassword) {
        showMessage('New passwords do not match', 'error');
        return;
    }
    
    if (newPassword.length < 6) {
        showMessage('New password must be at least 6 characters', 'error');
        return;
    }
    
    const changeButton = document.getElementById('changePasswordButton');
    changeButton.disabled = true;
    changeButton.textContent = 'Changing...';
    
    try {
        const response = await apiPost('/api/auth/change-password', { currentPassword, newPassword });
        
        const data = await response.json();
        
        if (response.ok && data.success) {
            showMessage('Password changed successfully', 'success');
            // Clear password fields
            document.getElementById('currentPassword').value = '';
            document.getElementById('newPassword').value = '';
            document.getElementById('confirmPassword').value = '';
        } else {
            showMessage(data.error || 'Failed to change password', 'error');
        }
    } catch (error) {
        console.error('Change password error:', error);
        showMessage('Network error', 'error');
    } finally {
        changeButton.disabled = false;
        changeButton.textContent = 'Change password';
    }
}

/**
 * Show message in message area
 */
function showMessage(text, type) {
    messageArea.textContent = text;
    messageArea.className = 'message-area visible ' + type;
}

/**
 * Hide message area
 */
function hideMessage() {
    messageArea.className = 'message-area';
    messageArea.textContent = '';
}

// Event listeners
closeButton.addEventListener('click', closeProfileModal);

// Close modal when clicking overlay background
modal.addEventListener('click', (e) => {
    if (e.target === modal) {
        closeProfileModal();
    }
});

// Close modal on Escape key
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
        closeProfileModal();
    }
});

profileForm.addEventListener('submit', handleSaveProfile);
passwordForm.addEventListener('submit', handleChangePassword);
